import React, { useEffect, useState } from "react";
import { EyeIcon, EyeOffIcon, LockClosedIcon } from "@heroicons/react/outline";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetPasswordRequest,
  clearResetPasswordSuccess,
} from "../../redux/action";
import toast from "react-hot-toast";
import { RegisterButton } from "../Buttons";
import { FormError } from "./FormError";
import { useParams } from "react-router";

export const ResetPasswordForm = ({ isAdmin }) => {
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [passType, setPassType] = useState(true);
  const [passType1, setPassType1] = useState(true);

  const history = useHistory();
  const { token } = useParams();

  const dispatch = useDispatch();

  const {
    resetPasswordSuccess,
    resetPasswordError,
    resetPasswordLoading,
    user,
  } = useSelector((state) => {
    const {
      success: { resetPassword: resetPasswordSuccess },
      errors: { resetPassword: resetPasswordError },
    } = state.ajaxStatuses;

    const { resetPasswordLoading } = state.loadingIndicator;

    const { user } = state.userData;

    return {
      resetPasswordSuccess,
      resetPasswordError,
      resetPasswordLoading,
      user,
    };
  });

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: yup.object({
      password: yup.string().required("Enter password"),
    }),

    onSubmit: (prop) => {
      //
      if (prop.password !== confirmPassword) {
        toast.error("Password does not match", {
          duration: 3000,
        });
      } else {
        let formData = prop;

        dispatch(resetPasswordRequest({ formData, token }));
      }
    },
  });

  useEffect(() => {
    if (resetPasswordError) {
      toast.error(resetPasswordError, {
        duration: 3000,
      });
    }
  }, [resetPasswordError]);

  useEffect(() => {
    if (resetPasswordSuccess) {
      toast.success(resetPasswordSuccess, {
        duration: 7000,
      });

      history.push("/login");

      dispatch(clearResetPasswordSuccess());
    }
  }, [resetPasswordSuccess]);

  return (
    <div className="shadow  py-16 px-4  md:px-8 md:py-8  ">
      <div className="text-3xl">Reset password</div>
      <form onSubmit={formik.handleSubmit} className="grid grid-cols-1 ">
        <div className="grid grid-rows-1  mb-10">
          <div className="pt-8">
            <div>
              <div
                className="
    flex items-center   
    py-1 bg-gray-100 "
              >
                <LockClosedIcon className="h-6 text-gray-600 mr-2" />
                <input
                  type={passType ? "password" : "text"}
                  className="
 py-2 px-4   border border-darkNav w-full focus:outline-none
          placeholder-gray-200::placeholder placeholder-opacity-75
          "
                  name="password"
                  {...formik.getFieldProps("password")}
                  placeholder="Password"
                />
                {passType ? (
                  <EyeIcon
                    onClick={() => setPassType((type) => !type)}
                    className="h-6 text-gray-600 ml-2 cursor-pointer "
                  />
                ) : (
                  <EyeOffIcon
                    onClick={() => setPassType((type) => !type)}
                    className="h-6 text-gray-600 ml-2 cursor-pointer "
                  />
                )}
              </div>
              {formik.errors.password && formik.touched.password && (
                <FormError message={formik.errors.password} />
              )}
            </div>

            <div>
              <div
                className="
    flex items-center  
    py-1 bg-gray-100 "
              >
                <LockClosedIcon className="h-6 text-gray-600 mr-2" />
                <input
                  type={passType1 ? "password" : "text"}
                  className="
         py-2 px-4   border border-darkNav w-full focus:outline-none
          placeholder-gray-200::placeholder placeholder-opacity-75
          "
                  placeholder="Confirm password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {passType1 ? (
                  <EyeIcon
                    onClick={() => setPassType1((type) => !type)}
                    className="
          h-6 text-gray-600 ml-2 cursor-pointer "
                  />
                ) : (
                  <EyeOffIcon
                    onClick={() => setPassType1((type) => !type)}
                    className="h-6 text-gray-600 ml-2 cursor-pointer "
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <RegisterButton
            loading={resetPasswordLoading}
            disable={!(formik.dirty && formik.isValid)}
            action={formik.handleSubmit}
            text="Reset password"
          />
        </div>
      </form>
    </div>
  );
};
